import type { TOC } from '@ember/component/template-only';
import SensitiveFieldShield from 'garaje/components/sensitive-field-shield';
import SensitiveRevealToggle from 'garaje/components/sensitive-reveal-toggle';

interface SensitiveColumnHeaderSignature {
  Args: {
    name: string;
  };
  Element: HTMLSpanElement;
}

export default <template>
  <span class="inline-flex items-center" ...attributes>
    <SensitiveFieldShield />
    <SensitiveRevealToggle @name={{@name}} />
  </span>
</template> satisfies TOC<SensitiveColumnHeaderSignature>;
